const desktop = `(min-width: 801px)`;
const mobile = `(max-width: 800px)`;

export { desktop, mobile };
